/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { StickySeverity } from "./StickySeverity";
import {
  StickySeverityFromJSON,
  StickySeverityFromJSONTyped,
  StickySeverityToJSON,
  StickySeverityToJSONTyped,
} from "./StickySeverity";
import type { StickyCategory } from "./StickyCategory";
import {
  StickyCategoryFromJSON,
  StickyCategoryFromJSONTyped,
  StickyCategoryToJSON,
  StickyCategoryToJSONTyped,
} from "./StickyCategory";

/**
 *
 * @export
 * @interface UpdateStickyRequest
 */
export interface UpdateStickyRequest {
  /**
   *
   * @type {string}
   * @memberof UpdateStickyRequest
   */
  title: string;
  /**
   *
   * @type {string}
   * @memberof UpdateStickyRequest
   */
  description?: string | null;
  /**
   *
   * @type {StickyCategory}
   * @memberof UpdateStickyRequest
   */
  category?: StickyCategory | null;
  /**
   *
   * @type {StickySeverity}
   * @memberof UpdateStickyRequest
   */
  severity?: StickySeverity | null;
}

/**
 * Check if a given object implements the UpdateStickyRequest interface.
 */
export function instanceOfUpdateStickyRequest(
  value: object,
): value is UpdateStickyRequest {
  if (!("title" in value) || value["title"] === undefined) return false;
  return true;
}

export function UpdateStickyRequestFromJSON(json: any): UpdateStickyRequest {
  return UpdateStickyRequestFromJSONTyped(json, false);
}

export function UpdateStickyRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): UpdateStickyRequest {
  if (json == null) {
    return json;
  }
  return {
    title: json["title"],
    description: json["description"] == null ? undefined : json["description"],
    category:
      json["category"] == null
        ? undefined
        : StickyCategoryFromJSON(json["category"]),
    severity:
      json["severity"] == null
        ? undefined
        : StickySeverityFromJSON(json["severity"]),
  };
}

export function UpdateStickyRequestToJSON(json: any): UpdateStickyRequest {
  return UpdateStickyRequestToJSONTyped(json, false);
}

export function UpdateStickyRequestToJSONTyped(
  value?: UpdateStickyRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    title: value["title"],
    description: value["description"],
    category: StickyCategoryToJSON(value["category"]),
    severity: StickySeverityToJSON(value["severity"]),
  };
}
